<template>
    <div class="agent-protocol">
        <span class="form-href-terms" @click.stop="gotoAgreement">《法行宝律师智能体入驻服务协议》</span>
        <img
            ref="tip"
            class="icon"
            src="https://lvlin-base.bj.bcebos.com/fe-saas/page/law-info/tip-icon-black-1.png"
            alt=""
        />
        <veui-popover
            target="tip" position="top-start"
            overlay-class="agent-protocol-popover"
        >
            <div class="popover-title">
                一、什么是律师智能体：
            </div>
            <div class="popover-content">
                律师智能体是您的在线AI分身，利用文心大模型能力和您个人专业知识内容，它能在您忙碌时即时回答用户常见问题，给出专业法律见解与建议，能够智能评估问题价值，并引导用户主动提供线索。
            </div>
            <div class="popover-title">
                二、律师智能体设置：
            </div>
            <div class="popover-content">
                <p>开启后，您的智能体将在用户相关场景中展示并参与回复。</p>
                <p>您可随时通过左侧菜单「律师智能体-角色设置」进行上线或下线操作。</p>
            </div>
            <div class="popover-title">
                三、哪里能看到我的智能体？
            </div>
            <div class="popover-content">
                <div class="popover-content-image">
                    <img src="https://lvlin-fe-saas.cdn.bcebos.com/material/agent-protocol/agent-2.png">
                    <img src="https://lvlin-fe-saas.cdn.bcebos.com/material/agent-protocol/agent-1.png">
                </div>
            </div>
        </veui-popover>
    </div>
</template>

<script>
import {Popover} from 'veui';

export default {
    name: 'AgentProtocol',

    components: {
        'veui-popover': Popover
    },

    methods: {
        /**
         * 打开智能体协议文件
         */
        gotoAgreement() {
            window.open('https://lvlin-fe-saas.cdn.bcebos.com/agent-rule.pdf');
        }
    }
};
</script>

<style lang="less" scoped>
.agent-protocol {
    display: flex;
    align-items: center;

    .form-href-terms {
        font-size: 14px;
        color: #0052cc;
        cursor: pointer;
    }

    .icon {
        width: 16px;
        height: 16px;
    }
}

.tip-first-line {
    margin-bottom: 20px;
}

.tip-second-line {
    color: #848b99;
}

.agent-protocol-popover {
    /deep/.veui-tooltip {
        max-width: 510px;
    }

    /deep/.veui-tooltip-content {
        margin: 20px;
    }

    .popover-title {
        color: #1e1f24;
        font-family: PingFang SC;
        font-weight: 500;
        font-size: 14px;
        line-height: 1;
    }

    .popover-content {
        color: #1e1f24;
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        margin-top: 10px;
        margin-bottom: 14px;

        .popover-content-image {
            display: flex;

            img {
                width: 229px;
                height: 192px;

                &:first-child {
                    margin-right: 11px;
                }
            }
        }
    }
}
</style>
